import config from "../../config.js";
import RequestManager from "../request.js";

export default class ErreurAffichable {
    constructor(obj) {
        this.type = obj.type;
        this.titre = obj.titre;
        this.message = obj.message;
        this.hasBeenSeen = obj.hasBeenSeen;
        this.idErreur = obj.idErreur;
    }

    // URI de base pour les appels à l'API Erreur.
    // GETTER (evalue a chaque acces) et NON champ statique fige a l'import : config.urlBackEnd
    // est reecrit apres login vers le BackEndLink du client (/final/, ou vit ErreurController).
    // Un champ statique restait fige sur /backend/ (BackEndParent, sans ErreurController) -> 404.
    static get uri() { return config.urlBackEnd + "Erreur"; }

    // Renvoie TOUJOURS un tableau : RequestManager.get avale les erreurs reseau/HTTP
    // (404/500...) et renvoie undefined. On normalise ici pour que les appelants
    // (poller AffichageErreur) ne plantent pas sur `data.length` quand le backend est KO.
    static async getAllErreurs() {
        const data = await RequestManager.get(this.uri);
        return Array.isArray(data) ? data : [];
    }

    static getErreurById(id) {
        return RequestManager.get(`${this.uri}/${id}`);
    }

    static ajouterErreur(erreur) {
        return RequestManager.post(this.uri, erreur)
            .then(response => response)
            .catch(error => console.error("ErreurAffichable.ajouterErreur -->", error));
    }

    static consulterErreur(id) {
        return RequestManager.put(`${this.uri}/${id}/consulter`)
            .then(response => response)
            .catch(error => console.error("ErreurAffichable.consulterErreur -->", error));
    }

    static supprimerErreur(id) {
        return RequestManager.delete(`${this.uri}/${id}`)
            .then(response => response)
            .catch(error => console.error("ErreurAffichable.supprimerErreur -->", error));
    }
}
